export default "__VITE_ASSET__lCHnVdPY__"